import { render, staticRenderFns } from "./search_block.vue?vue&type=template&id=66a68a3c"
import script from "./search_block.vue?vue&type=script&lang=js"
export * from "./search_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports